/**
 * @file Generic Badge component.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  badgeStyle: PropTypes.oneOf([
    'primary',
    'secondary',
    'success',
    'success-vibrant',
    'info',
    'warning',
    'danger',
    'glass',
    'gold',
    'link',
    'reset',
    'yellow',
    'dark-transparent',
    'dark-transparent-light',
    'purple',
    'orange',
    'blue-light',
    'blue-mid-light',
    'blue-mid',
    'white',
  ]),
  badgeSize: PropTypes.oneOf(['xs', 'sm', 'lg']),
  badgeOutline: PropTypes.bool,
  round: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

const Badge = ({
  badgeStyle = 'primary',
  badgeSize,
  badgeOutline,
  className,
  round,
  children,
  ...props
}) => {
  const classes = classNames({
    badge: true,
    [`badge-${badgeStyle}`]: !!badgeStyle,
    [`badge-${badgeSize}`]: badgeSize,
    'badge-round': round,
    'badge-outline': !!badgeOutline,
    [`badge-outline-${badgeStyle}`]: !!badgeOutline && !!badgeStyle,
    [className]: className,
  });

  return (
    <span className={classes} {...props}>
      {children}
    </span>
  );
};

Badge.propTypes = propTypes;

export default Badge;
